/* eslint-disable react/prop-types */
import React from 'react';
import { ErrorMessage } from '@gsa/afp-component-library';

const ReviewItemError = ({ error }) => {
  const getEcErrors = (ecErrors, tabTitle) => {
    if (!ecErrors?.length) return null;
    const ecErrs = ecErrors.filter((e) => e.ecCode !== 'Conflicts');
    const conflictsErr = ecErrors.find((e) => e.ecCode === 'Conflicts');
    return (
      <>
        <div>{tabTitle} tab errors:</div>
        <ul>
          {ecErrs.length > 0 && (
            <li>
              <ErrorMessage className="text-normal">
                There are {ecErrs.length} incomplete EC inputs:{' '}
                {ecErrs.map((e) => e.ecCode).join(', ')}
              </ErrorMessage>
            </li>
          )}
          {conflictsErr && (
            <li>
              <ErrorMessage className="text-normal">
                Conflicts error: {conflictsErr.message}
              </ErrorMessage>
            </li>
          )}
        </ul>
      </>
    );
  };

  if (error.errorMessage)
    return (
      <ErrorMessage className="text-normal">{error.errorMessage}</ErrorMessage>
    );

  const {
    lineTabErrors,
    lineDetailTabErrors,
    minReqTabErrors,
    optEqTabErrors,
    engineTabErrors,
    colorsTabErrors,
    documentsTabError,
  } = error.lineTemplateErrors ?? {};
  const noColorAddedError = colorsTabErrors?.find((e) => e.colorCode === '');

  return (
    <>
      {lineTabErrors?.length > 0 && (
        <>
          <div>Line tab errors:</div>
          <ul>
            {lineTabErrors.map((fieldError) => (
              <li>
                <ErrorMessage className="text-normal">
                  {fieldError.message}
                </ErrorMessage>
              </li>
            ))}
          </ul>
        </>
      )}
      {lineDetailTabErrors?.length > 0 && (
        <>
          <div>Line detail tab errors:</div>
          <ul>
            {lineDetailTabErrors.map((fieldError) => (
              <li>
                <ErrorMessage className="text-normal">
                  {fieldError.message}
                </ErrorMessage>
              </li>
            ))}
          </ul>
        </>
      )}
      {getEcErrors(minReqTabErrors, 'Minimum requirements')}
      {getEcErrors(optEqTabErrors, 'Optional equipment')}
      {engineTabErrors?.length > 0 && (
        <>
          <div>Engine and fuel tab errors:</div>
          <ul>
            {engineTabErrors.map((e) => (
              <li>
                <ErrorMessage className="text-normal">
                  {e.ecCode}: {e.message}
                </ErrorMessage>
              </li>
            ))}
          </ul>
        </>
      )}
      {noColorAddedError && (
        <div>
          <div>Colors tab errors:</div>
          <ul>
            <li>
              <ErrorMessage className="text-normal">
                {noColorAddedError.errors[0].message}
              </ErrorMessage>
            </li>
          </ul>
        </div>
      )}
      {!noColorAddedError && colorsTabErrors?.length > 0 && (
        <>
          <div>Colors tab errors:</div>
          <ul>
            {colorsTabErrors.map((colorError) => (
              <li>
                <div>{colorError.colorCode}</div>
                <ul>
                  {colorError.errors.map((fieldError) => (
                    <li>
                      <ErrorMessage className="text-normal">
                        {fieldError.message}
                      </ErrorMessage>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </>
      )}
      {documentsTabError && (
        <>
          <div>Documentation tab errors:</div>
          <ul>
            <li>
              <ErrorMessage className="text-normal">
                {documentsTabError}
              </ErrorMessage>
            </li>
          </ul>
        </>
      )}
    </>
  );
};

export default ReviewItemError;
